// src/law_pages/PrivacyPolicy.tsx
import { useEffect } from "react";

export default function PrivacyPolicy() {
  useEffect(() => {
    document.title = "Политика обработки персональных данных — Mira";
  }, []);

  return (
    <main className="mx-auto max-w-3xl px-4 py-6">
      <h1 className="text-2xl font-bold mb-2">
        Политика в отношении обработки персональных данных PWA «Mira» (v1.1)
      </h1>

      <p className="text-sm text-gray-600">
        <strong>Действует с:</strong> 22.08.2025
        <br />
        <strong>Оператор:</strong> Бабин Максим Викторович, ИНН 165048100405,
        адрес для корреспонденции: 423812, Россия, Республика Татарстан, г.
        Набережные Челны, бульвар 60-летия Октября, д. 8, кв. 2
        <br />
        <strong>Контакты по вопросам ПД:</strong>{" "}
        <a
          className="underline"
          href="mailto:stroimpechki@yandex.ru"
          rel="noopener noreferrer"
        >
          stroimpechki@yandex.ru
        </a>
      </p>

      <p className="mt-4">
        <a
          href="/docs/privacy_policy_v1.1.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="underline font-medium"
        >
          Скачать PDF-версию
        </a>
      </p>

      <hr className="my-6" />

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">0. Сфера действия и возраст</h2>
        <p>
          0.1. Политика применима к PWA «Mira», расположенному по адресу{" "}
          <a
            className="underline"
            href="https://24mira.ru"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://24mira.ru
          </a>
          , а также к связанным приложениям/виджетам/интерфейсам.
        </p>
        <p>
          0.2. Сервис предназначен для пользователей 18+. Мы не обрабатываем
          данные несовершеннолетних сознательно.
        </p>
      </section>

      <section className="space-y-4 mt-6">
        <h2 className="text-xl font-semibold">1. Общие положения</h2>
        <p>
          1.1. Политика определяет порядок и условия обработки персональных
          данных (далее — «ПД») пользователей Сервиса.
        </p>
        <p>
          1.2. Оператор публикует Политику в свободном доступе и обеспечивает к
          ней постоянный доступ.
        </p>
        <p>
          1.3. Используя Сервис, пользователь подтверждает, что ознакомлен с
          настоящей Политикой, Пользовательским соглашением и Публичной
          офертой.
        </p>
      </section>

      <section className="space-y-4 mt-6">
        <h2 className="text-xl font-semibold">
          2. Термины и правовые основания
        </h2>
        <p>
          2.1. Персональные данные — любая информация, относящаяся к прямо или
          косвенно определённому лицу.
        </p>
        <p>
          2.2. «Процессор» — лицо, обрабатывающее ПД по поручению Оператора.
        </p>
        <p>
          2.3. «Партнёр-оператор» — самостоятельный оператор ПД, получающий ПД
          для собственных целей на основании отдельного согласия пользователя.
        </p>
        <p>2.4. Основания обработки ПД:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            исполнение договора с пользователем (регистрация, оказание услуг);
          </li>
          <li>
            согласие пользователя (в т.ч. на маркетинг, профилирование, передачу
            партнёрам);
          </li>
          <li>
            законный интерес Оператора (информационная безопасность, antifraud,
            ограниченная сервисная аналитика);
          </li>
          <li>
            исполнение обязанностей по закону (в т.ч. расчёты и выдача чека
            самозанятым через «Мой Налог»).
          </li>
        </ul>
      </section>

      <section className="space-y-4 mt-6">
        <h2 className="text-xl font-semibold">
          3. Категории и источники данных
        </h2>
        <p>3.1. Мы обрабатываем следующие данные:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            <strong>Регистрация и идентификация:</strong> имя/ник, телефон и/или
            email, пароль/токены, ID-учётной записи.
          </li>
          <li>
            <strong>Профиль/контент:</strong> аватар/фото (по желанию),
            заметки/отзывы, загруженные файлы.
          </li>
          <li>
            <strong>Взаимодействие и тех.данные:</strong> cookie/SDK-идентификаторы,
            IP/UA, язык/время/клики, настройки, push-токены, события приложения
            (логи).
          </li>
          <li>
            <strong>Платежи:</strong> суммы, статусы, токены платёжного
            провайдера; платёжные реквизиты передаются провайдеру, а не
            Оператору.
          </li>
          <li>
            <strong>Геолокация</strong> (при явном разрешении в интерфейсе ОС).
          </li>
          <li>
            <strong>Сообщения/чаты</strong> (если эти функции будут запущены в
            будущем).
          </li>
        </ul>
        <p>
          3.2. Источники: сам пользователь; его устройства (cookie/SDK);
          процессоры (платёжные, хостинг, аналитика, рассылки);
          партнёры-операторы — при отдельном согласии.
        </p>
        <p>
          3.3. Специальные категории ПД (здоровье, убеждения и пр.) не
          обрабатываются без специальных оснований. Биометрия — только при
          отдельном письменном согласии.
        </p>
      </section>

      <section className="space-y-4 mt-6">
        <h2 className="text-xl font-semibold">4. Цели обработки</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            регистрация, идентификация и предоставление функционала Сервиса;
          </li>
          <li>
            биллинг, расчёты, выставление чеков самозанятым через «Мой Налог»;
          </li>
          <li>техподдержка и коммуникация с пользователем;</li>
          <li>
            обеспечение безопасности, предотвращение злоупотреблений и
            мошенничества (antifraud scoring);
          </li>
          <li>сервисная аналитика и A/B-тесты (в разумных пределах);</li>
          <li>
            <strong>персонализация и профилирование</strong> — только при
            отдельном согласии;
          </li>
          <li>
            <strong>маркетинговые коммуникации</strong> — только при
            предварительном согласии;
          </li>
          <li>
            <strong>передача ПД партнёрам-операторам</strong> — только при
            отдельном согласии;
          </li>
          <li>
            <strong>трансграничная передача</strong> — при необходимости и с
            соблюдением требований уведомления надзорного органа;
          </li>
          <li>исследование и статистика на обезличенных данных.</li>
        </ul>
      </section>

      <section className="space-y-4 mt-6">
        <h2 className="text-xl font-semibold">5. Cookie/SDK и трекеры</h2>
        <p>
          5.1. Используем категории трекеров:{" "}
          <strong>строго необходимые</strong> (авторизация, безопасность),{" "}
          <strong>аналитические</strong>, <strong>маркетинговые</strong>.
        </p>
        <p>
          5.2. Управление предпочтениями — в{" "}
          <a className="underline" href="/privacy-center">
            Центре конфиденциальности
          </a>
          . Строго необходимые трекеры нельзя отключить.
        </p>
        <p>
          5.3. Подробный перечень cookie/SDK и сроки их хранения приведены в
          Приложении Б.
        </p>
      </section>

      <section className="space-y-4 mt-6">
        <h2 className="text-xl font-semibold">
          6. Маркетинговые коммуникации
        </h2>
        <p>
          6.1. Реклама по email/SMS/мессенджерам/звонкам/push направляется
          только при наличии предварительного согласия.
        </p>
        <p>
          6.2. Отписка от рекламы доступна в каждом сообщении и в настройках
          профиля.
        </p>
        <p>
          6.3. Оператор ведёт учёт доказательств выданных согласий (время,
          источник, версия текста).
        </p>
      </section>

      <section className="space-y-4 mt-6">
        <h2 className="text-xl font-semibold">
          7. Профилирование и автоматизированные решения
        </h2>
        <p>
          7.1. Профилирование для персональных рекомендаций/рекламы
          осуществляется только с отдельного согласия и может быть отключено
          пользователем.
        </p>
        <p>
          7.2. Исключительно автоматизированные решения, порождающие юридические
          последствия, не применяются, за исключением прямо предусмотренных
          законом случаев.
        </p>
      </section>

      <section className="space-y-4 mt-6">
        <h2 className="text-xl font-semibold">8. Передача третьим лицам</h2>
        <p>
          8.1. <strong>Процессоры (по поручению):</strong> платёжные провайдеры,
          рассылочные платформы, хостинг/облака, аналитика, мониторинг и пр. —
          на основании договоров поручения с требованиями конфиденциальности и
          безопасности.
        </p>
        <p>
          8.2. <strong>Партнёры-операторы (самостоятельные цели):</strong>{" "}
          передача осуществляется только при отдельном согласии пользователя с
          указанием категорий получателей и целей.
        </p>
        <p>
          8.3. Перечень категорий получателей и примеры процессоров/партнёров
          приведены в Приложении А и на странице{" "}
          <a className="underline" href="/partners">
            «Партнёры и получатели»
          </a>
          .
        </p>
      </section>

      <section className="space-y-4 mt-6">
        <h2 className="text-xl font-semibold">
          9. Трансграничная передача и локализация
        </h2>
        <p>9.1. Первичная запись и хранение ПД граждан РФ обеспечиваются на серверах в РФ.</p>
        <p>
          9.2. При передаче ПД за пределы РФ (в т.ч. при использовании
          иностранных сервисов) Оператор действует в соответствии с требованиями
          о предварительном уведомлении надзорного органа.
        </p>
        <p>
          9.3. Страны/категории получателей за рубежом и меры защиты указываются
          в Политике и на странице «Партнёры и получатели».
        </p>
        <p>
          9.4. Статус уведомления о трансграничной передаче: не направлялось (по
          состоянию на 22.08.2025 трансграничная передача не осуществляется).
        </p>
      </section>

      <section className="space-y-4 mt-6">
        <h2 className="text-xl font-semibold">
          10. Сроки хранения (Data Retention)
        </h2>
        <p>
          Мы храним ПД не дольше, чем это необходимо для целей обработки либо
          предусмотрено законом. Базовые сроки:
        </p>

        <div className="overflow-auto">
          <table className="w-full text-sm border border-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="text-left p-2 border-b">Категория</th>
                <th className="text-left p-2 border-b">Срок</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-t">
                <td className="p-2">Учётная запись, профиль</td>
                <td className="p-2">срок действия договора + 3 года</td>
              </tr>
              <tr className="border-t">
                <td className="p-2">Платёжные данные/док-ты</td>
                <td className="p-2">5 лет (учёт/налоговые требования)</td>
              </tr>
              <tr className="border-t">
                <td className="p-2">Поддержка (тикеты)</td>
                <td className="p-2">3 года</td>
              </tr>
              <tr className="border-t">
                <td className="p-2">Логи безопасности</td>
                <td className="p-2">до 12 месяцев</td>
              </tr>
              <tr className="border-t">
                <td className="p-2">Сырьё аналитики</td>
                <td className="p-2">
                  до 24 месяцев (с последующей агрегацией/обезличиванием)
                </td>
              </tr>
              <tr className="border-t">
                <td className="p-2">Маркетинговые согласия</td>
                <td className="p-2">
                  срок согласия + 3 года хранения доказательств
                </td>
              </tr>
              <tr className="border-t">
                <td className="p-2">Сообщения/чаты (если запустим)</td>
                <td className="p-2">
                  не менее 6 месяцев (в соответствии с требованиями к ОРИ)
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p>
          Иные сроки — согласно Приложению А и внутреннему регламенту хранения.
        </p>
      </section>

      <section className="space-y-4 mt-6">
        <h2 className="text-xl font-semibold">11. Права пользователя</h2>
        <p>
          11.1. Пользователь вправе запросить доступ к своим ПД; потребовать их
          уточнения, удаления, ограничения; отозвать согласия; возразить против
          профилирования; получить сведения о трансграничной передаче.
        </p>
        <p>
          11.2. Запросы направляются через форму:{" "}
          <a className="underline" href="/privacy-request">
            https://24mira.ru/privacy-request
          </a>
          , либо на email:{" "}
          <a className="underline" href="mailto:stroimpechki@yandex.ru">
            stroimpechki@yandex.ru
          </a>
          . Ответ предоставляется в предусмотренный законом срок.
        </p>
        <p>
          11.3. Пользователь вправе обжаловать действия Оператора в
          уполномоченный орган и/или суд.
        </p>
      </section>

      <section className="space-y-4 mt-6">
        <h2 className="text-xl font-semibold">12. Безопасность ПД</h2>
        <p>
          12.1. Оператор принимает необходимые правовые, организационные и
          технические меры защиты ПД, включая контроль доступа, шифрование
          каналов связи (TLS), журналирование действий, резервное копирование,
          аудит и обучение.
        </p>
        <p>
          12.2. Уровень защиты ИСПДн определяется с учётом актуальной модели
          угроз.
        </p>
      </section>

      <section className="space-y-4 mt-6">
        <h2 className="text-xl font-semibold">
          13. Особые категории и биометрия
        </h2>
        <p>
          13.1. Особые категории ПД не обрабатываются без специальных оснований.
        </p>
        <p>
          13.2. Биометрические ПД (лицо/голос) обрабатываются только при наличии
          отдельного письменного согласия и лишь при запуске соответствующих
          функций.
        </p>
      </section>

      <section className="space-y-4 mt-6">
        <h2 className="text-xl font-semibold">
          14. Потенциальный статус организатора распространения информации (ОРИ)
        </h2>
        <p>
          14.1. При запуске функций обмена сообщениями Сервис может подпадать под
          статус ОРИ, что влечёт дополнительные обязанности по хранению
          контента/метаданных в РФ и выполнению требований законодательства. Об
          этом будет сообщено дополнительно в Условиях и Политике.
        </p>
      </section>

      <section className="space-y-4 mt-6">
        <h2 className="text-xl font-semibold">15. Правопреемство</h2>
        <p>
          15.1. В случае реорганизации/смены Оператора права и обязанности по
          обработке ПД переходят к правопреемнику при соблюдении условий
          настоящей Политики. Пользователь будет уведомлён о переходе.
        </p>
      </section>

      <section className="space-y-4 mt-6">
        <h2 className="text-xl font-semibold">16. Изменение Политики</h2>
        <p>
          16.1. Актуальная версия размещается по адресу:{" "}
          <a className="underline" href="/privacy-policy">
            https://24mira.ru/privacy-policy
          </a>
          . При существенных изменениях Оператор уведомляет пользователей в
          интерфейсе Сервиса.
        </p>
      </section>

      <section className="space-y-2 mt-6">
        <h2 className="text-xl font-semibold">17. Реквизиты и связь</h2>
        <p>
          <strong>Оператор:</strong> Бабин Максим Викторович, ИНН 165048100405
          <br />
          <strong>Email:</strong>{" "}
          <a className="underline" href="mailto:stroimpechki@yandex.ru">
            stroimpechki@yandex.ru
          </a>
          <br />
          <strong>Почтовый адрес:</strong> 423812, Россия, Республика
          Татарстан, г. Набережные Челны, бульвар 60-летия Октября, д. 8, кв. 2
        </p>
      </section>

      <hr className="my-6" />

      <section className="space-y-3 mt-6">
        <h3 className="text-lg font-semibold">
          Приложение А. Категории получателей и примеры контрагентов
        </h3>
        <p>
          <strong>Процессоры (по поручению):</strong>
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            <strong>ЮKassa / YooMoney</strong> — платёжный провайдер; страна:
            Россия; сайт: yookassa.ru. В т.ч. автоотправка данных чеков
            самозанятых в ФНС через «Мой Налог» при включении опции.
          </li>
          <li>
            <strong>Timeweb Cloud</strong> — хостинг/VPS; страна: Россия; сайт:
            timeweb.cloud.
          </li>
          <li>
            <strong>Системные сервисы рассылок (email/SMS/push)</strong> —
            будут подключены при запуске коммуникаций; перечень и условия будут
            добавлены на странице партнёров.
          </li>
        </ul>
        <p>
          <strong>
            Партнёры-операторы (самостоятельные цели) — только при отдельном
            согласии пользователя:
          </strong>
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            Рекламные сети/CPA-платформы — <em>не используются</em> в текущей
            версии. При подключении будет опубликован перечень
            категорий/примеров на странице партнёров.
          </li>
        </ul>
        <p>
          <strong>Аналитика/мониторинг:</strong>
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            <strong>Яндекс.Метрика</strong> — аналитика; страна: Россия; сайт:
            metrika.yandex.ru —{" "}
            <em>
              будет включена только после получения согласия в Центре
              конфиденциальности
            </em>
            .
          </li>
          <li>
            <strong>VK Ads Pixel</strong> — маркетинг/ретаргетинг; страна:
            Россия; сайт: vk.com/ads —{" "}
            <em>
              будет включён только после получения согласия в Центре
              конфиденциальности
            </em>
            .
          </li>
        </ul>
      </section>

      <section className="space-y-3 mt-6">
        <h3 className="text-lg font-semibold">
          Приложение Б. Таблица cookie/SDK (текущая конфигурация)
        </h3>
        <div className="overflow-auto">
          <table className="w-full text-sm border border-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="text-left p-2 border-b">Имя</th>
                <th className="text-left p-2 border-b">Провайдер</th>
                <th className="text-left p-2 border-b">Назначение</th>
                <th className="text-left p-2 border-b">Тип</th>
                <th className="text-left p-2 border-b">Срок</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-t">
                <td className="p-2">_pwa_session</td>
                <td className="p-2">Mira (24mira.ru)</td>
                <td className="p-2">
                  Сессия/авторизация (если используется cookie)
                </td>
                <td className="p-2">строго необходимо</td>
                <td className="p-2">до 30 дней</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="text-sm text-gray-700">
          Аналитические и маркетинговые cookie/SDK{" "}
          <strong>не используются</strong> в текущей версии. При их включении
          (Яндекс.Метрика, VK Pixel) появится баннер/Центр конфиденциальности, а
          таблица будет обновлена.
        </p>
      </section>

      <section className="space-y-3 mt-6">
        <h3 className="text-lg font-semibold">
          Приложение В. Контакты и реквизиты
        </h3>
        <p>
          Оператор: Бабин Максим Викторович, ИНН 165048100405 —{" "}
          <a className="underline" href="mailto:stroimpechki@yandex.ru">
            stroimpechki@yandex.ru
          </a>
        </p>
      </section>
    </main>
  );
}
